import React from 'react'
import {Flex, Dot} from '/app/src/component'


const DotProgress = ({currentPage})  => (
    <Flex>
        <Flex>
            <Dot active={true}/>
        </Flex>
        <Flex>
            <Dot active={1 <= currentPage}/>
        </Flex>
        <Flex>
            <Dot active={2 <= currentPage}/>
        </Flex>
    </Flex>
)

export default DotProgress;



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/DotProgress.js